// extracted by mini-css-extract-plugin
export var icon = "_6-1";
export var subtext = "_6-0";